import { AController } from "@eagerlogic/react-mvc";
import { ContactUsModel } from "../model/ContactUsModel";

export class ContactUsController extends AController<ContactUsModel> {

    protected createInitialModel(): ContactUsModel {
        var res = new ContactUsModel();

        return res;
    }

}